import { useApi } from "@/src/api/useApi";
import ProductListV1 from "@/src/components/product/ProductListV1";
import { ProductListType } from "@/src/types/product";

interface ProductSimilarProps {
  productId: number;
  title: string;
}

const ProductSimilar = ({ productId, title }: ProductSimilarProps) => {
  const { data, isLoading } = useApi<ProductListType>(
    `/product-similar?productId=${productId}`
  );

  if (isLoading || !data?.data || !data.data.rows?.length) return null;

  return (
    <section className="my-12" aria-label={`محصولات مشابه با ${title}`}>
      <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#246b20]">
        <span className="text-base text-gray-500 font-normal mr-2">{`محصولات مشابه ${title}`}</span>
      </h2>

      <ProductListV1 data={data.data.rows as any} />
    </section>
  );
};

export default ProductSimilar;
